import { parseDateOnly } from "@core/utils/formatDateOnly";

function dateOnlyTimestamp(value: Date): number {
  return new Date(value.getFullYear(), value.getMonth(), value.getDate()).getTime();
}

/**
 * Whether a required flag with an optional start date applies to a report-tag period.
 * Mirrors App\Support\ReportTag\RequiredStarting::isRequiredForPeriod.
 */
export function isRequiredForPeriod(
  isRequired: boolean,
  requiredAt: string | null | undefined,
  periodSince: string | null | undefined,
  periodUntil: string | null | undefined,
  asOf: Date = new Date()
): boolean {
  if (!isRequired) {
    return false;
  }

  if (!periodSince || !periodUntil) {
    return isRequired;
  }

  if (!requiredAt) {
    return true;
  }

  const startDate = parseDateOnly(requiredAt);
  const sinceDate = parseDateOnly(periodSince);
  const untilDate = parseDateOnly(periodUntil);

  if (!startDate || !sinceDate || !untilDate) {
    return isRequired;
  }

  const startTime = dateOnlyTimestamp(startDate);
  const sinceTime = dateOnlyTimestamp(sinceDate);
  const untilTime = dateOnlyTimestamp(untilDate);
  const asOfTime = dateOnlyTimestamp(asOf);

  if (startTime > untilTime) {
    return false;
  }

  if (startTime <= sinceTime) {
    return true;
  }

  return startTime <= asOfTime;
}
